<template>
<div v-if="Scores" class="my-3">
  <h5 class="mb-4">{{$t('Webportal.CX.Exploration.OverallScore')}}</h5>
    <DxChart
      :data-source="Scores"
      :size="{height: Height, width: Width}"
      class="mb-5"
    >
      <DxSeries
        argument-field="Date"
        value-field="Value"
        type="line"
        name="OverallScore"
        :color="getSeriesColor()"
      />
      <DxValueAxis
        :visual-range="[0, Scores[0].MaxRating + Scores[0].MaxRating * 0.1]"
      />
      <DxLegend
        vertical-alignment="bottom"
        horizontal-alignment="center"
        item-text-position="bottom"
        :font="{size: 14, weight: 600, color: 'black'}"
        :visible="false"
      />
      <DxTooltip 
        :enabled="true"
        :customize-tooltip="customizeTooltip"
      />
  </DxChart>
</div>
</template>

<script>
import { DxChart, DxSeries, DxTooltip, DxCommonSeriesSettings, DxLabel , DxCrosshair, DxLegend, DxValueAxis, DxTitle } from 'devextreme-vue/chart';

export default {
  name: "ScoresChart",
  components: {
    DxChart,
    DxSeries,
    DxValueAxis,
    DxLegend,
    DxTooltip
  },
  props: {
    Scores: Array,
    Width: {
      type: Number,
      default: 500
    },
    Height: {
      type: Number,
      default: 150
    },
    Caption: String
  },
  methods: {
    customizeTooltip(arg) {
      var dateString = new Date(arg.argument).toLocaleString('default', {month: 'short', year: 'numeric'});
      return { text: `${dateString}\n${arg.value}` };
    },
    getSeriesColor() {
      var theme = localStorage.getItem("user-theme");
      if(theme == 'dark') return 'white';
      else return 'black';
    },
  },
  watch: {
    Scores: {
      immediate: true,
      handler() {
        if(this.Scores) {
          this.Scores?.forEach(score => {
            score.Date = new Date(score.Date)
          });
        }
      }
    }
  },
}
</script>
